import { useEffect } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Remove os dados do usuário e token
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');

    // Exibe mensagem
    //message.success('Volte sempre!');

    // Redireciona para a página de login após 1 segundo
    const timer = setTimeout(() => {
      navigate('/login');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return null; // Não precisa renderizar nada
};

export default Logout;
